import React from "react";
import Trip from "../Components/Trip";
import SidebarLayout from "../Components/sidebar/SidebarLayout";

function Trips() {
  return (
    <>
      <SidebarLayout>
        <div style={{ position: "relative" }}>
          <Trip />
        </div>
      </SidebarLayout>
    </>
  );
}

export default Trips;
